import {LOCATION_CHANGE} from 'connected-react-router';

import {SET_CURRENT_PERSONA} from '../session/types';
import * as types from './types';

export const INITIAL_STATE = {
  messageHistory: false,
  alertsPanel: false,
  mapSelection: false,
  mapDetail: false,
  mapProvince: false,
  mapPolygon: false,
  mapMenu: false,
  mapSavedViews: false,
  mapPersonsList: false,
  mapSitesList: false,
  mapOccupantsList: false,
  mapAlertsList: false,
  mapPhysicalSecuritiesList: false,
  composeMessage: false,
};

const drawersReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.CLOSE_DRAWER:
      return {
        ...state,
        [action.payload.drawer]: false,
      };

    case types.OPEN_DRAWER:
      return {
        ...state,
        [action.payload.drawer]: true,
      };

    case types.TOGGLE_DRAWER:
      return {
        ...state,
        [action.payload.drawer]: !state[action.payload.drawer],
      };

    case types.OPEN_EXCLUSIVE:
      return {
        ...state,
        messageHistory: false,
        alertsPanel: false,
        mapSelection: false,
        mapDetail: false,
        mapMenu: false,
        mapSavedViews: false,
        mapPolygon: false,
        mapProvince: false,
        mapPersonsList: false,
        mapSitesList: false,
        mapOccupantsList: false,
        composeMessage: false,
        mapAlertsList: false,
        mapPhysicalSecuritiesList: false,
        [action.payload.drawer]: true,
      };

    case types.TOGGLE_EXCLUSIVE:
      return {
        ...state,
        messageHistory: false,
        alertsPanel: false,
        mapSelection: false,
        mapDetail: false,
        mapProvince: false,
        mapMenu: false,
        mapSavedViews: false,
        mapPolygon: false,
        mapPersonsList: false,
        mapSitesList: false,
        mapOccupantsList: false,
        composeMessage: false,
        mapAlertsList: false,
        mapPhysicalSecuritiesList: false,
        [action.payload.drawer]: !state[action.payload.drawer],
      };

    case types.OPEN_MAP_DETAIL_EXCLUSIVE:
      return {
        ...state,
        messageHistory: false,
        alertsPanel: false,
        mapDetail: false,
        mapMenu: false,
        mapSavedViews: false,
        mapProvince: false,
        mapAlertsList: false,
        mapPhysicalSecuritiesList: false,
        [action.payload.drawer]: true,
      };

    case LOCATION_CHANGE:
      return {
        ...state,
        messageHistory: false,
        alertsPanel: false,
        mapMenu: false,
        mapSavedViews: false,
        mapPolygon: false,
        mapProvince: false,
        mapPersonsList: false,
        mapSitesList: false,
        mapOccupantsList: false,
        mapAlertsList: false,
        mapPhysicalSecuritiesList: false,

        // temporary - commenting out because drawers close when toast messages are displayed (MessageRecipientsDrawer)
        // composeMessage: false
      };

    case SET_CURRENT_PERSONA:
    case types.CLOSE_ALL:
      return INITIAL_STATE;

    default:
      return state;
  }
};

export default drawersReducer;
